import { render } from "./WeeklyReport.vue?vue&type=template&id=edcd5a3c"
import script from "./WeeklyReport.vue?vue&type=script&lang=js"
export * from "./WeeklyReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__